import dayjs from "dayjs";

export default function (value, format = 'DD/MM/YYYY') {
  if (value) {
    return dayjs(value).format(format);
  } else {
    return '';
  }
}
